/**
 * Návrhy kódov zostáv a dielcov — schéma A / A1 / A2a (KOLO 134).
 *
 * Zostava: `A`, `B` … `Z`, `AA`, `AB` …; dielec: `{zostava}{n}` (`A1`,
 * `A2`…); lepená vrstva sendviča: `{rodič}{a, b…}` (`A2a`, `A2b`).
 *
 * Kód **drží backend** (`services/precislovanie.py::zarovnaj_kody` po
 * každej úprave) a toto je len návrh, aby nový riadok mal správny kód
 * hneď a neblikol. Skladá ho tá istá schéma ako
 * `backend/.../services/kod_polozky.py` — paritu stráži test
 * `test_kod_polozky.py::TestParitaSFrontendom`.
 */

interface HasKod {
  kod: string;
}

/** `0` → `A` … `25` → `Z`, `26` → `AA` (ako stĺpce v Exceli). */
export function pismena(poradie: number): string {
  let out = "";
  let n = poradie + 1;
  while (n > 0) {
    const zvysok = (n - 1) % 26;
    out = String.fromCharCode(65 + zvysok) + out;
    n = Math.floor((n - 1) / 26);
  }
  return out;
}

/** Ďalší kód dielca v zostave: `{zostavaKod}{max + 1}`. */
export function suggestNextKod(zostavaKod: string, existing: HasKod[]): string {
  const vzor = new RegExp(`^${zostavaKod}(\\d+)$`);
  let max = 0;
  for (const d of existing) {
    const m = vzor.exec(d.kod ?? "");
    if (m) max = Math.max(max, Number(m[1]));
  }
  return `${zostavaKod}${max + 1}`;
}

/** Ďalšia zostava vo variante — písmeno za existujúcimi. */
export function suggestNextZostavaKod(existing: HasKod[]): string {
  return pismena(existing.length);
}

/** Kód `i`-tej lepenej vrstvy (od 1): `A2` → `A2a`, `A2b`… */
export function kodVrstvy(rodicKod: string, i: number): string {
  return `${rodicKod}${pismena(i - 1).toLowerCase()}`;
}
